/**
 * PrivacyPage — public privacy policy for omniforce.dev.
 *
 * Honest early-stage scaffold. The legal text is generic and short
 * because Omniforce hasn't shipped a public hosted service yet — the
 * page exists so reviewers and startup-program forms can verify the
 * domain has a privacy URL. Replace with counsel-reviewed copy before
 * onboarding any external user data.
 */
import * as React from "react";
import { LandingNav } from "@/components/landing/LandingNav";
import { LandingFooter } from "@/components/landing/LandingFooter";
import "@/components/landing/landing.css";

export function PrivacyPage() {
  const [theme, setTheme] = React.useState<"dark" | "light">("dark");

  React.useEffect(() => {
    document.title = "Privacy · Omniforce";
  }, []);

  return (
    <div className="landing" data-theme={theme}>
      <LandingNav
        onThemeToggle={() => setTheme((t) => (t === "dark" ? "light" : "dark"))}
        theme={theme}
      />
      <main>
        <section className="section">
          <div className="container" style={{ maxWidth: 760 }}>
            <div className="eyebrow">Legal</div>
            <h1 className="section__title" style={{ marginTop: 8 }}>
              Privacy Policy
            </h1>
            <p style={{ color: "var(--fg-muted)", marginTop: 8 }}>
              Last updated: {new Date().toISOString().slice(0, 10)}
            </p>

            <h2 style={{ marginTop: 40 }}>Who we are</h2>
            <p>
              Omniforce is the maker of Omni — The Real Jarvis. Reach us at{" "}
              <a href="mailto:omanandswami2005@gmail.com">
                omanandswami2005@gmail.com
              </a>
              .
            </p>

            <h2 style={{ marginTop: 32 }}>What we collect</h2>
            <p>
              omniforce.dev is a public marketing site. It does not require an
              account. We collect minimal request logs (IP, user-agent, URL,
              timestamp) for security and to keep the site online. We do not
              sell, share, or monetise this data.
            </p>
            <p>
              If you sign up for Omni — our product — you'll be presented with
              a separate, product-specific privacy notice at that point. This
              page only covers the marketing site.
            </p>

            <h2 style={{ marginTop: 32 }}>Cookies</h2>
            <p>
              omniforce.dev does not set tracking cookies. A single
              functionality cookie may be used to remember your theme
              preference (light / dark); it stores no identifying data.
            </p>

            <h2 style={{ marginTop: 32 }}>Third parties</h2>
            <p>
              The site is hosted on Vercel and uses Cloudflare for DNS. These
              providers process request metadata on our behalf under their own
              privacy commitments.
            </p>

            <h2 style={{ marginTop: 32 }}>Your rights</h2>
            <p>
              Email{" "}
              <a href="mailto:omanandswami2005@gmail.com">
                omanandswami2005@gmail.com
              </a>{" "}
              if you want any logs related to you deleted, or if you have any
              other question about how we handle data.
            </p>

            <h2 style={{ marginTop: 32 }}>Changes</h2>
            <p>
              We'll update this page when our data practices change. The "Last
              updated" date at the top reflects the current version.
            </p>
          </div>
        </section>
        <LandingFooter />
      </main>
    </div>
  );
}
